import script from "./QuotationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuotationPage.vue?vue&type=script&setup=true&lang=ts"

import "./QuotationPage.vue?vue&type=style&index=0&id=42b84611&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42b84611"]])

export default __exports__